export let itemListProps = {
    key: 0,
    id: 0,
    inventory_item_id: null,
    item_detail: {id: 0, sku_code: '', article_name: '', unit_name: ''},
    qty: 1,
    notes: '',
    item_edit: 0
}

export let dataProps = {
    id: 0,
    store_id: null,
    challan_number: null, 
    issue_date: new Date(), 
    issued_to_staff_id: null,
    issued_by_staff_id: null, 
    production_id: null, 
    tailoring_item_id: null,
    work_order_number: '',
    notes: '', 
    
    item_list: [JSON.parse(JSON.stringify(itemListProps))],
}


// WEBPACK FOOTER //
// ./src/store/modules/productionItemIssue/properties.js